module.exports = __webpack_public_path__ + "static/img/464_phase_function_Paper_Points.c27bf84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/464_phase_function_Paper_Points.png
// module id = q1w8
// module chunks = 0